import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "doodle-toolbox__buttons" }
const _hoisted_2 = { class: "doodle-toolbox__brush-control" }
const _hoisted_3 = ["value"]

import { ref } from 'vue'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import DraggableContainer from '@/components/doodle/DraggableContainer.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'DoodleToolbox',
  emits: ["changeDoodleBrushSize", "changeDoodleColor", "changeDoodleTool", "closeDoodle"],
  setup(__props, { emit: __emit }) {

const emits = __emit
const doodleColor = ref<string>('#a8071a')

async function downloadDoodle() {
  const draggableContainer = document.getElementById('draggable-container')
  if (draggableContainer) draggableContainer.style.display = 'none'
  const doodleFrame = document.getElementById('doodle-frame')
  if (doodleFrame) doodleFrame.style.display = 'none'
  try {
    // inspiration from this source: https://www.codingnepalweb.com/how-to-take-screenshot-vanilla-javascript/
    // asking permission to use a media input to record current tab
    const stream = await navigator.mediaDevices.getDisplayMedia({
      // @ts-ignore
      preferCurrentTab: true
    })
    const video = document.createElement('video')
    function videoEventListener() {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = video.videoWidth
      canvas.height = video.videoHeight
      video.play() // playing the video so the drawn image won't be black or blank
      ctx?.drawImage(video, 0, 0, canvas.width, canvas.height) // drawing an image of the captured video stream
      stream.getVideoTracks()[0].stop() // terminating first video track of the stream
      const image = canvas.toDataURL('image/png')
      downloadImage(image, 'DB doodle.png')
    }
    video.addEventListener('loadedmetadata', videoEventListener)
    video.srcObject = stream // passing capture stream data as video source object
    await new Promise((resolve) => setTimeout(resolve, 100)) // The delay is for making sure the image is saved before the container is displayed again and for the event listener to not be removed too soon
    video.removeEventListener('loadedmetadata', videoEventListener)
  } catch (err) {
    // alert("Failed to capture screenshot!") // if image couldn't capture by any reason, then alert the msg
    console.error('Error: ' + err)
  }
  if (draggableContainer) draggableContainer.style.display = 'flex'
  if (doodleFrame) doodleFrame.style.display = 'unset'
}
function downloadImage(image, filename) {
  var lnk = document.createElement('a'),
    e
  lnk.download = filename
  lnk.href = image
  if (document.createEvent) {
    e = document.createEvent('MouseEvents')
    e.initMouseEvent(
      'click',
      true,
      true,
      window,
      0,
      0,
      0,
      0,
      0,
      false,
      false,
      false,
      false,
      0,
      null
    )
    lnk.dispatchEvent(e)
  }
}
function selectColor(event) {
  doodleColor.value = event.target.value
  emits('changeDoodleColor', event.target.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DraggableContainer, null, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "doodle-toolbox__brush-control__button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('changeDoodleBrushSize', 'decrease')))
          }, " - "),
          _createElementVNode("input", {
            type: "color",
            value: doodleColor.value,
            class: "doodle-toolbox__color-picker",
            onInput: selectColor
          }, null, 40, _hoisted_3),
          _createElementVNode("button", {
            class: "doodle-toolbox__brush-control__button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('changeDoodleBrushSize', 'increase')))
          }, " + ")
        ]),
        _createVNode(ButtonText, {
          iconLeft: require('@/design-system/assets/icons/Icon-Brush-01-Blue.svg'),
          size: "medium-icon",
          onOnClicked: _cache[2] || (_cache[2] = ($event: any) => (emits('changeDoodleTool', 'free')))
        }, null, 8, ["iconLeft"]),
        _createVNode(ButtonText, {
          iconLeft: require('@/design-system/assets/icons/Icon-Forward-Slash-Blue.svg'),
          size: "medium-icon",
          onOnClicked: _cache[3] || (_cache[3] = ($event: any) => (emits('changeDoodleTool', 'line')))
        }, null, 8, ["iconLeft"]),
        _createVNode(ButtonText, {
          iconLeft: require('@/design-system/assets/icons/Icon-Square-Blue.svg'),
          size: "medium-icon",
          onOnClicked: _cache[4] || (_cache[4] = ($event: any) => (emits('changeDoodleTool', 'rectangle')))
        }, null, 8, ["iconLeft"]),
        _createVNode(ButtonText, {
          iconLeft: require('@/design-system/assets/icons/Icon-Circle-Blue.svg'),
          size: "medium-icon",
          onOnClicked: _cache[5] || (_cache[5] = ($event: any) => (emits('changeDoodleTool', 'circle')))
        }, null, 8, ["iconLeft"]),
        _createVNode(ButtonText, {
          iconLeft: require('@/design-system/assets/icons/Icon-Type-Blue.svg'),
          size: "medium-icon",
          onOnClicked: _cache[6] || (_cache[6] = ($event: any) => (emits('changeDoodleTool', 'text')))
        }, null, 8, ["iconLeft"]),
        _createVNode(ButtonText, {
          iconLeft: require('@/design-system/assets/icons/Icon-Eraser-Blue.svg'),
          size: "medium-icon",
          onOnClicked: _cache[7] || (_cache[7] = ($event: any) => (emits('changeDoodleTool', 'eraser')))
        }, null, 8, ["iconLeft"]),
        _createVNode(ButtonPrimary, {
          iconLeft: require('@/design-system/assets/icons/Icon-Download-White.svg'),
          size: "medium-icon",
          style: {"margin-top":"8px"},
          onOnClicked: downloadDoodle
        }, null, 8, ["iconLeft"]),
        _createVNode(ButtonPrimary, {
          iconLeft: require('@/design-system/assets/icons/Icon-X.svg'),
          size: "medium-icon",
          style: {"margin-top":"8px"},
          onOnClicked: _cache[8] || (_cache[8] = ($event: any) => (emits('closeDoodle')))
        }, null, 8, ["iconLeft"])
      ])
    ]),
    _: 1
  }))
}
}

})